export default {
    zh: {
        // 通用上传
        clickOrDragImages: '点击或拖拽上传图片',
        supportedImageFormats: '支持 JPEG、PNG、GIF、WEBP、JPG 格式',
        imageConstraints: '最大 {maxSize}MB，分辨率最大 {maxResolution} x {maxResolution} 像素',
        addMore: '添加更多',
        uploading: '上传中...',
        success: '成功上传 {count} 个文件',

        // 错误信息
        errors: {
            invalidImageType: '请上传支持的图片格式',
            fileTooLarge: '文件大小不能超过 {maxSize}MB',
            resolutionTooLarge: '图片分辨率不能超过 {maxResolution} x {maxResolution} 像素',
            invalidImageFile: '无效的图片文件',
            multipleFilesNotAllowed: '不支持多文件上传',
            replaceExistingFile: '请先移除现有文件',
            uploadFailed: '上传失败'
        },
        placeholderText: '上传',
        drop_here: '将图片拖拽到此处'
    },
    en: {
        // 通用上传
        clickOrDragImages: 'Click or drag to upload images',
        supportedImageFormats: 'Supports JPEG, PNG, GIF, WEBP, JPG formats',
        imageConstraints: 'Max {maxSize}MB, resolution max {maxResolution} x {maxResolution} pixels',
        addMore: 'Add More',
        uploading: 'Uploading...',
        success: 'Successfully uploaded {count} files',

        // 错误信息
        errors: {
            invalidImageType: 'Please upload supported image formats',
            fileTooLarge: 'File size cannot exceed {maxSize}MB',
            resolutionTooLarge: 'Image resolution cannot exceed {maxResolution} x {maxResolution} pixels',
            invalidImageFile: 'Invalid image file',
            multipleFilesNotAllowed: 'Multiple file upload not supported',
            replaceExistingFile: 'Please remove existing file first',
            uploadFailed: 'Upload failed'
        },
        placeholderText: 'Upload',
        drop_here: 'Drop images here'
    },
    ja: {
        // 通用上传
        clickOrDragImages: 'クリックまたはドラッグして画像をアップロード',
        supportedImageFormats: 'JPEG、PNG、GIF、WEBP、JPG形式をサポート',
        imageConstraints: '最大{maxSize}MB、解像度最大{maxResolution} x {maxResolution}ピクセル',
        addMore: 'さらに追加',
        uploading: 'アップロード中...',
        success: '{count}個のファイルをアップロードしました',

        // 错误信息
        errors: {
            invalidImageType: 'サポートされている画像形式をアップロードしてください',
            fileTooLarge: 'ファイルサイズは{maxSize}MBを超えることはできません',
            resolutionTooLarge: '画像解像度は{maxResolution} x {maxResolution}ピクセルを超えることはできません',
            invalidImageFile: '無効な画像ファイル',
            multipleFilesNotAllowed: '複数ファイルアップロードはサポートされていません',
            replaceExistingFile: '既存のファイルを先に削除してください',
            uploadFailed: 'アップロードに失敗しました'
        },
        placeholderText: 'アップロード',
        drop_here: 'ここに画像をドラッグしてください'
    },
    ko: {
        // 通用上传
        clickOrDragImages: '클릭하거나 드래그하여 이미지 업로드',
        supportedImageFormats: 'JPEG, PNG, GIF, WEBP, JPG 형식 지원',
        imageConstraints: '최대 {maxSize}MB, 해상도 최대 {maxResolution} x {maxResolution} 픽셀',
        addMore: '더 추가',
        uploading: '업로드 중...',
        success: '{count}개 파일을 성공적으로 업로드했습니다',

        // 错误信息
        errors: {
            invalidImageType: '지원되는 이미지 형식을 업로드하세요',
            fileTooLarge: '파일 크기는 {maxSize}MB를 초과할 수 없습니다',
            resolutionTooLarge: '이미지 해상도는 {maxResolution} x {maxResolution} 픽셀을 초과할 수 없습니다',
            invalidImageFile: '잘못된 이미지 파일',
            multipleFilesNotAllowed: '다중 파일 업로드는 지원되지 않습니다',
            replaceExistingFile: '기존 파일을 먼저 제거하세요',
            uploadFailed: '업로드 실패'
        },
        placeholderText: '업로드',
        drop_here: '이미지를 여기에 드래그하세요'
    },
    es: {
        // 通用上传
        clickOrDragImages: 'Haz clic o arrastra para subir imágenes',
        supportedImageFormats: 'Soporta formatos JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'Máximo {maxSize}MB, resolución máxima {maxResolution} x {maxResolution} píxeles',
        addMore: 'Agregar más',
        uploading: 'Subiendo...',
        success: 'Se subieron {count} archivos exitosamente',

        // 错误信息
        errors: {
            invalidImageType: 'Por favor sube formatos de imagen soportados',
            fileTooLarge: 'El tamaño del archivo no puede exceder {maxSize}MB',
            resolutionTooLarge: 'La resolución de la imagen no puede exceder {maxResolution} x {maxResolution} píxeles',
            invalidImageFile: 'Archivo de imagen inválido',
            multipleFilesNotAllowed: 'No se soporta la subida de múltiples archivos',
            replaceExistingFile: 'Por favor elimina el archivo existente primero',
            uploadFailed: 'Error en la subida'
        },
        placeholderText: 'Subir',
        drop_here: '이미지를 여기에 드래귰하세요'
    },
    fr: {
        // 通用上传
        clickOrDragImages: 'Cliquez ou glissez-déposez pour télécharger des images',
        supportedImageFormats: 'Supporte les formats JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'Max {maxSize}MB, résolution max {maxResolution} x {maxResolution} pixels',
        addMore: 'Ajouter plus',
        uploading: 'Téléchargement...',
        success: '{count} fichiers téléchargés avec succès',

        // 错误信息
        errors: {
            invalidImageType: 'Veuillez télécharger des formats d\'image supportés',
            fileTooLarge: 'La taille du fichier ne peut pas dépasser {maxSize}MB',
            resolutionTooLarge: 'La résolution de l\'image ne peut pas dépasser {maxResolution} x {maxResolution} pixels',
            invalidImageFile: 'Fichier image invalide',
            multipleFilesNotAllowed: 'Le téléchargement de fichiers multiples n\'est pas supporté',
            replaceExistingFile: 'Veuillez d\'abord supprimer le fichier existant',
            uploadFailed: 'Échec du téléchargement'
        },
        placeholderText: 'Télécharger',
        drop_here: 'Téléchargez les images ici'
    },
    de: {
        // 通用上传
        clickOrDragImages: 'Klicken oder ziehen Sie Bilder zum Hochladen',
        supportedImageFormats: 'Unterstützt JPEG, PNG, GIF, WEBP, JPG Formate',
        imageConstraints: 'Max {maxSize}MB, Auflösung max {maxResolution} x {maxResolution} Pixel',
        addMore: 'Mehr hinzufügen',
        uploading: 'Hochladen...',
        success: '{count} Dateien erfolgreich hochgeladen',

        // 错误信息
        errors: {
            invalidImageType: 'Bitte unterstützte Bildformate hochladen',
            fileTooLarge: 'Dateigröße darf {maxSize}MB nicht überschreiten',
            resolutionTooLarge: 'Bildauflösung darf {maxResolution} x {maxResolution} Pixel nicht überschreiten',
            invalidImageFile: 'Ungültige Bilddatei',
            multipleFilesNotAllowed: 'Mehrfachdatei-Upload wird nicht unterstützt',
            replaceExistingFile: 'Bitte entfernen Sie zuerst die vorhandene Datei',
            uploadFailed: 'Upload fehlgeschlagen'
        },
        placeholderText: 'Hochladen',
        drop_here: 'Bilder hier ablegen'
    },
    ru: {
        // 通用上传
        clickOrDragImages: 'Нажмите или перетащите изображения для загрузки',
        supportedImageFormats: 'Поддерживает форматы JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'Макс {maxSize}MB, разрешение макс {maxResolution} x {maxResolution} пикселей',
        addMore: 'Добавить еще',
        uploading: 'Загрузка...',
        success: 'Успешно загружено {count} файлов',

        // 错误信息
        errors: {
            invalidImageType: 'Пожалуйста, загрузите поддерживаемые форматы изображений',
            fileTooLarge: 'Размер файла не может превышать {maxSize}MB',
            resolutionTooLarge: 'Разрешение изображения не может превышать {maxResolution} x {maxResolution} пикселей',
            invalidImageFile: 'Неверный файл изображения',
            multipleFilesNotAllowed: 'Загрузка нескольких файлов не поддерживается',
            replaceExistingFile: 'Пожалуйста, сначала удалите существующий файл',
            uploadFailed: 'Ошибка загрузки'
        },
        placeholderText: 'Загрузить',
        drop_here: 'Перетащите изображения сюда'
    },
    pt: {
        // 通用上传
        clickOrDragImages: 'Clique ou arraste imagens para fazer upload',
        supportedImageFormats: 'Suporta formatos JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'Máx {maxSize}MB, resolução máx {maxResolution} x {maxResolution} pixels',
        addMore: 'Adicionar mais',
        uploading: 'Fazendo upload...',
        success: '{count} arquivos enviados com sucesso',

        // 错误信息
        errors: {
            invalidImageType: 'Por favor, faça upload de formatos de imagem suportados',
            fileTooLarge: 'O tamanho do arquivo não pode exceder {maxSize}MB',
            resolutionTooLarge: 'A resolução da imagem não pode exceder {maxResolution} x {maxResolution} pixels',
            invalidImageFile: 'Arquivo de imagem inválido',
            multipleFilesNotAllowed: 'Upload de múltiplos arquivos não é suportado',
            replaceExistingFile: 'Por favor, remova o arquivo existente primeiro',
            uploadFailed: 'Falha no upload'
        },
        placeholderText: 'Fazer upload',
        drop_here: 'Carregue imagens aqui'
    },
    it: {
        // 通用上传
        clickOrDragImages: 'Clicca o trascina immagini per caricare',
        supportedImageFormats: 'Supporta formati JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'Max {maxSize}MB, risoluzione max {maxResolution} x {maxResolution} pixel',
        addMore: 'Aggiungi altro',
        uploading: 'Caricamento...',
        success: '{count} file caricati con successo',

        // 错误信息
        errors: {
            invalidImageType: 'Carica formati di immagine supportati',
            fileTooLarge: 'La dimensione del file non può superare {maxSize}MB',
            resolutionTooLarge: 'La risoluzione dell\'immagine non può superare {maxResolution} x {maxResolution} pixel',
            invalidImageFile: 'File immagine non valido',
            multipleFilesNotAllowed: 'Il caricamento di più file non è supportato',
            replaceExistingFile: 'Rimuovi prima il file esistente',
            uploadFailed: 'Caricamento fallito'
        },
        placeholderText: 'Carica',
        drop_here: 'Trascina immagini qui'
    },
    ar: {
        // 通用上传
        clickOrDragImages: 'انقر أو اسحب الصور للرفع',
        supportedImageFormats: 'يدعم تنسيقات JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints: 'الحد الأقصى {maxSize}MB، الدقة القصوى {maxResolution} x {maxResolution} بكسل',
        addMore: 'إضافة المزيد',
        uploading: 'جاري الرفع...',
        success: 'تم رفع {count} ملف بنجاح',

        // 错误信息
        errors: {
            invalidImageType: 'يرجى رفع تنسيقات الصور المدعومة',
            fileTooLarge: 'لا يمكن أن يتجاوز حجم الملف {maxSize}MB',
            resolutionTooLarge: 'لا يمكن أن تتجاوز دقة الصورة {maxResolution} x {maxResolution} بكسل',
            invalidImageFile: 'ملف صورة غير صالح',
            multipleFilesNotAllowed: 'رفع ملفات متعددة غير مدعوم',
            replaceExistingFile: 'يرجى إزالة الملف الموجود أولاً',
            uploadFailed: 'فشل الرفع'
        },
        placeholderText: 'رفع',
        drop_here: 'اسحب الصور هنا'
    },
    tw: {
        // 通用上传
        clickOrDragImages: '點擊或拖拽上傳圖片',
        supportedImageFormats: '支援 JPEG、PNG、GIF、WEBP、JPG 格式',
        imageConstraints:
            '最大 {maxSize}MB，解析度最大 {maxResolution} x {maxResolution} 像素',
        addMore: '添加更多',
        uploading: '上傳中...',
        success: '成功上傳 {count} 個文件',

        // 错误信息
        errors: {
            invalidImageType: '請上傳支援的圖片格式',
            fileTooLarge: '檔案大小不可超過 {maxSize}MB',
            resolutionTooLarge:
                '圖片解析度不可超過 {maxResolution} x {maxResolution} 像素',
            invalidImageFile: '無效的圖片檔案',
            multipleFilesNotAllowed: '不支援多檔上傳',
            replaceExistingFile: '請先移除現有檔案',
            uploadFailed: '上傳失敗'
        },
        placeholderText: '上傳',
        drop_here: '將圖片拖拽到此處'
    },
    pl: {
        // 通用上传
        clickOrDragImages: 'Kliknij lub przeciągnij, aby przesłać obrazy',
        supportedImageFormats: 'Obsługuje formaty JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints:
            'Maks. {maxSize}MB, rozdzielczość maks. {maxResolution} x {maxResolution} pikseli',
        addMore: 'Dodaj więcej',
        uploading: 'Przesyłanie...',
        success: 'Pomyślnie przesłano {count} plików',

        // 错误信息
        errors: {
            invalidImageType: 'Prześlij obsługiwane formaty obrazów',
            fileTooLarge: 'Rozmiar pliku nie może przekroczyć {maxSize}MB',
            resolutionTooLarge:
                'Rozdzielczość obrazu nie może przekroczyć {maxResolution} x {maxResolution} px',
            invalidImageFile: 'Nieprawidłowy plik obrazu',
            multipleFilesNotAllowed:
                'Przesyłanie wielu plików nie jest obsługiwane',
            replaceExistingFile: 'Najpierw usuń istniejący plik',
            uploadFailed: 'Przesyłanie nie powiodło się'
        },
        placeholderText: 'Prześlij',
        drop_here: 'Przesuń obrazy tutaj'
    },
    th: {
        // 通用上传
        clickOrDragImages: 'คลิกหรือลากเพื่ออัปโหลดรูปภาพ',
        supportedImageFormats: 'รองรับรูปแบบ JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints:
            'สูงสุด {maxSize}MB, ความละเอียดสูงสุด {maxResolution} x {maxResolution} พิกเซล',
        addMore: 'เพิ่มอีก',
        uploading: 'กำลังอัปโหลด...',
        success: 'อัปโหลดไฟล์ {count} ไฟล์สำเร็จแล้ว',

        // 错误信息
        errors: {
            invalidImageType: 'กรุณาอัปโหลดรูปแบบรูปภาพที่รองรับ',
            fileTooLarge: 'ขนาดไฟล์ต้องไม่เกิน {maxSize}MB',
            resolutionTooLarge:
                'ความละเอียดภาพต้องไม่เกิน {maxResolution} x {maxResolution} พิกเซล',
            invalidImageFile: 'ไฟล์รูปภาพไม่ถูกต้อง',
            multipleFilesNotAllowed: 'ไม่รองรับการอัปโหลดหลายไฟล์',
            replaceExistingFile: 'โปรดลบไฟล์เดิมก่อน',
            uploadFailed: 'อัปโหลดล้มเหลว'
        },
        placeholderText: 'อัปโหลด',
        drop_here: 'ลากรูปภาพมาที่นี่'
    },
    da: {
        // 通用上传
        clickOrDragImages: 'Klik eller træk for at uploade billeder',
        supportedImageFormats: 'Understøtter JPEG, PNG, GIF, WEBP, JPG formater',
        imageConstraints:
            'Max {maxSize}MB, opløsning max {maxResolution} x {maxResolution} pixels',
        addMore: 'Tilføj flere',
        uploading: 'Uploader...',
        success: 'Uploadede {count} filer',

        // 错误信息
        errors: {
            invalidImageType: 'Upload venligst understøttede billedformater',
            fileTooLarge: 'Filstørrelsen må ikke overstige {maxSize}MB',
            resolutionTooLarge:
                'Billedopløsningen må ikke overstige {maxResolution} x {maxResolution} pixels',
            invalidImageFile: 'Ugyldig billedfil',
            multipleFilesNotAllowed: 'Upload af flere filer understøttes ikke',
            replaceExistingFile: 'Fjern den eksisterende fil først',
            uploadFailed: 'Upload mislykkedes'
        },
        placeholderText: 'Upload',
        drop_here: 'Upload images here'
    },
    no: {
        // 通用上传
        clickOrDragImages: 'Klikk eller dra for å laste opp bilder',
        supportedImageFormats: 'Støtter JPEG, PNG, GIF, WEBP, JPG-formater',
        imageConstraints:
            'Maks {maxSize}MB, oppløsning maks {maxResolution} x {maxResolution} piksler',
        addMore: 'Legg til flere',
        uploading: 'Laster opp...',
        success: 'Lastet opp {count} filer',

        // 错误信息
        errors: {
            invalidImageType: 'Last opp støttede bildeformater',
            fileTooLarge: 'Filstørrelsen kan ikke overstige {maxSize}MB',
            resolutionTooLarge:
                'Bildeoppløsningen kan ikke overstige {maxResolution} x {maxResolution} piksler',
            invalidImageFile: 'Ugyldig bildefil',
            multipleFilesNotAllowed:
                'Opplasting av flere filer støttes ikke',
            replaceExistingFile: 'Fjern eksisterende fil først',
            uploadFailed: 'Opplasting mislyktes'
        },
        placeholderText: 'Last opp',
        drop_here: 'Last opp images here'
    },
    nl: {
        // 通用上传
        clickOrDragImages: 'Klik of sleep om afbeeldingen te uploaden',
        supportedImageFormats: 'Ondersteunt JPEG, PNG, GIF, WEBP, JPG formaten',
        imageConstraints:
            'Max {maxSize}MB, resolutie max {maxResolution} x {maxResolution} pixels',
        addMore: 'Voeg meer toe',
        uploading: 'Uploaden...',
        success: 'Succesvol {count} bestanden geüpload',

        // 错误信息
        errors: {
            invalidImageType: 'Upload ondersteunde afbeeldingsformaten',
            fileTooLarge: 'Bestandsgrootte mag niet groter zijn dan {maxSize}MB',
            resolutionTooLarge:
                'Afbeeldingsresolutie mag niet groter zijn dan {maxResolution} x {maxResolution} pixels',
            invalidImageFile: 'Ongeldig afbeeldingsbestand',
            multipleFilesNotAllowed:
                'Meerdere bestanden uploaden wordt niet ondersteund',
            replaceExistingFile: 'Verwijder eerst het bestaande bestand',
            uploadFailed: 'Uploaden mislukt'
        },
        placeholderText: 'Uploaden',
        drop_here: 'Uploaden images here'
    },
    id: {
        // 通用上传
        clickOrDragImages: 'Klik atau seret untuk mengunggah gambar',
        supportedImageFormats: 'Mendukung format JPEG, PNG, GIF, WEBP, JPG',
        imageConstraints:
            'Maks {maxSize}MB, resolusi maks {maxResolution} x {maxResolution} piksel',
        addMore: 'Tambah Lagi',
        uploading: 'Mengunggah...',
        success: 'Berhasil mengunggah {count} file',

        // 错误信息
        errors: {
            invalidImageType: 'Harap unggah format gambar yang didukung',
            fileTooLarge: 'Ukuran file tidak boleh melebihi {maxSize}MB',
            resolutionTooLarge:
                'Resolusi gambar tidak boleh melebihi {maxResolution} x {maxResolution} piksel',
            invalidImageFile: 'File gambar tidak valid',
            multipleFilesNotAllowed: 'Unggah banyak file tidak didukung',
            replaceExistingFile: 'Silakan hapus file yang ada terlebih dahulu',
            uploadFailed: 'Unggah gagal'
        },
        placeholderText: 'Unggah',
        drop_here: 'Unggah images here'
    },
    tr: {
        // 通用上传
        clickOrDragImages: 'Görselleri yüklemek için tıklayın veya sürükleyin',
        supportedImageFormats: 'JPEG, PNG, GIF, WEBP, JPG formatlarını destekler',
        imageConstraints:
            'Maks {maxSize}MB, çözünürlük maks {maxResolution} x {maxResolution} piksel',
        addMore: 'Daha Fazla Ekle',
        uploading: 'Yükleniyor...',
        success: '{count} dosya başarıyla yüklendi',

        // 错误信息
        errors: {
            invalidImageType: 'Lütfen desteklenen görsel formatlarını yükleyin',
            fileTooLarge: 'Dosya boyutu {maxSize}MB değerini aşamaz',
            resolutionTooLarge:
                'Görüntü çözünürlüğü {maxResolution} x {maxResolution} pikseli aşamaz',
            invalidImageFile: 'Geçersiz görüntü dosyası',
            multipleFilesNotAllowed:
                'Birden fazla dosya yükleme desteklenmiyor',
            replaceExistingFile: 'Lütfen önce mevcut dosyayı kaldırın',
            uploadFailed: 'Yükleme başarısız'
        },
        placeholderText: 'Yükle',
        drop_here: 'Yükle images here'
    },
}
